import React, { ReactNode } from "react";
import {
  Dialog,
  DialogBody,
  DialogModalType,
  DialogSurface,
  makeStyles,
} from "@fluentui/react-components";

interface ModalProps {
  children: ReactNode;
  open: boolean;
  modalType: DialogModalType;
}

const useStyles = makeStyles({
  dialogSurface: {
    width: "700px",
    maxWidth: "90vw",
    maxHeight: "90vh",
    overflow: "auto",
  },
  dialogBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "8px",
    padding: "0",
  },
});

const Modal: React.FC<ModalProps> = ({ children, open, modalType }) => {
  const styles = useStyles();

  return (
    <Dialog modalType={modalType} open={open}>
      <DialogSurface className={styles.dialogSurface}>
        <DialogBody className={styles.dialogBody}>{children}</DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default Modal;
